var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"section-scroll"},[_c('div',{staticClass:"scroll-btn up",attrs:{"tabindex":"0"},on:{"click":function($event){return _vm.scroll(false)}}}),_c('div',{staticClass:"scroll-btn down",attrs:{"tabindex":"0"},on:{"click":function($event){return _vm.scroll(true)}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }